import React from 'react';
import useLiveValue from '../useLiveValue';

const SUB_SCORES = [
    { label: 'Efficiency', value: 0 },
    { label: 'Reliability', value: 0 },
    { label: 'Safety', value: 0 },
];

const HealthScoreWidget = ({ config }) => {
    const { settings = {} } = config;
    const score = useLiveValue(settings.value ?? 0, { id: config.id, min: 0, max: 100, volatility: 0.015 });
    const accent = settings.color || '#4318FF';
    const rounded = Math.round(score);
    const tone = rounded >= 85 ? '#0ca30c' : rounded >= 60 ? '#d69e00' : '#d03b3b';

    return (
        <div className="health-score-widget" title={`Health score: ${rounded}/100`}>
            <div className="health-score-widget__ring" style={{ '--pct': rounded, '--tone': tone }}>
                <span>{rounded}</span>
            </div>
            <div className="health-score-widget__subs">
                {SUB_SCORES.map((s) => (
                    <div className="health-score-widget__sub" key={s.label}>
                        <span className="health-score-widget__sub-label">{s.label}</span>
                        <div className="health-score-widget__sub-track">
                            <div className="health-score-widget__sub-fill" style={{ width: `${s.value}%`, backgroundColor: accent }} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HealthScoreWidget;
